'use client';

import 'BomdisoftComponents/admin-frame/styles.css';
import { Button } from 'BomdisoftComponents/buttons/index';
import { Fallback } from 'BomdisoftComponents/fallback/index';
import { getLanguageCode, getLanguageFromLocale, somethingWentWrongT, tryAgain } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';
import { useEffect } from 'react';

export type GlobalErrorPageProps = {
  error: Error & { digest?: string };
  onError?: (error: Error & { digest?: string }) => void;
  reset: () => void;
};

export const GlobalErrorPage = ({ error, onError, reset }: GlobalErrorPageProps) => {
  const params = useParams();
  const language = getLanguageFromLocale(typeof params?.lang === 'string' ? params.lang : undefined);

  useEffect(() => {
    onError?.(error);
  }, [error, onError]);

  return (
    <html lang={getLanguageCode(language)}>
      <body>
        <div className='bomdisoft-admin-error'>
          <Fallback message={somethingWentWrongT[language]} />
          <Button color='info' data-testid='global-error-retry' onClick={() => reset()} variant='contained'>
            {tryAgain[language]}
          </Button>
        </div>
      </body>
    </html>
  );
};
